import { OnChanges } from '@angular/core';

interface IComponentPropChange<T> {
    currentValue: T;
}

export interface IFirstSimpleChange<T> extends IComponentPropChange<T> {
    previousValue: undefined;
    firstChange: true;
    isFirstChange(): true;
}

export interface INextSimpleChange<T> extends IComponentPropChange<T> {
    previousValue: T;
    firstChange: false;
    isFirstChange(): false;
}

/**
 * @deprecated Use signals and effects instead.
 */
export type ISimpleChange<T> = IFirstSimpleChange<T> | INextSimpleChange<T>;

/**
 * @deprecated Use signals and effects instead.
 */

export type ISimpleChanges<TComponent extends OnChanges> = { [prop in keyof TComponent]?: ISimpleChange<TComponent[prop]> };

interface IdentifiableChange<T> {
    id: T;
}

export function changed<T extends IdentifiableChange<string | number>>(change: ISimpleChange<T> | undefined): boolean {
    if (!change) {
        return false;
    }

    const empty: IdentifiableChange<undefined> = { id: undefined };

    const current = change.currentValue || empty;
    const previous = change.previousValue || empty;

    return current.id !== previous.id;
}
